import SuccessScreen from '../new-order/SuccessScreen/SuccessScreen';
import ExtensionSuccessScreen from '../new-order/SuccessScreen/ExtensionSuccessScreen';
import PlansScreenAdapter from './PlansScreen/PlansScreenAdapter';
import AuthScreen from './AuthScreen/AuthScreen';
import PaymentMethodsScreenAffiliateAdapter from './PaymentMethodsScreen/PaymentMethodsScreenAdapter';
import CardFormScreenAdapter from './CardFormScreen/CardFormScreenAdapter';

import { useAffiliateSelector } from '@/store/affiliate';
import { STEPS } from '@/store/affiliate/stepsSlice';

const StepsSwitch = () => {
  const currentStep = useAffiliateSelector((state) => state.steps.current);

  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- should not be possible for this slice (not really sure now)
  switch (currentStep) {
    case STEPS.plans:
      return <PlansScreenAdapter />;

    case STEPS.auth:
      return <AuthScreen />;

    case STEPS.paymentMethods:
      return <PaymentMethodsScreenAffiliateAdapter />;

    case STEPS.cardForm:
      return <CardFormScreenAdapter />;

    case STEPS.success:
      return <SuccessScreen />;

    case STEPS.successWithDownload:
      return <SuccessScreen withDownload />;

    case STEPS.successForExtensionUser:
      return <ExtensionSuccessScreen />;

    default:
      return <h1>🫠</h1>;
  }
};

export default StepsSwitch;
